import { Flex } from "@mantine/core";
import LoginPage from "../login/LoginPage";

const PageNotFound = () => {
    return (
        <Flex justify="center" direction="column" align="center">
            <h1>404 - Not Found!</h1>
            <br/>
            <LoginPage />
        </Flex>
    );
};

export default PageNotFound;